export default {
    root: ({props, state, parent, instance}) => {
        // console.log(instance, props);
        // props.onshow = (e) => console.log("show");
        // instance.onshow = (e) => {
        //     document.body.classList.add(["overflow-hidden", "md:overflow-auto"]);
        // };
        // instance.onOverlayAfterLeave = (e) => {
        //     document.body.classList.remove(["overflow-hidden", "md:overflow-auto"]);
        // };
        // props.checkmark = true;
        return {
            class: [
                // Display and Position
                "inline-flex",
                "relative",

                // Shape
                {"rounded-md": parent.instance.$name !== "InputGroup"},
                {
                    "first:rounded-l-md rounded-none last:rounded-r-md": parent.instance.$name == "InputGroup",
                },
                {
                    "border-0 border-y border-l last:border-r": parent.instance.$name == "InputGroup",
                },
                {
                    "first:ml-0 ml-[-1px]": parent.instance.$name == "InputGroup" && !props.showButtons,
                },

                // Color and Background
                "bg-stone-50 dark:bg-stone-900",
                "border",
                {"dark:border-stone-700": parent.instance.$name != "InputGroup"},
                {"dark:border-stone-600": parent.instance.$name == "InputGroup"},
                {"border-stone-300 dark:border-stone-600": !props.invalid},

                // Invalid State
                "invalid:focus:ring-red-200",
                "invalid:hover:border-red-500",
                {"border-red-500 dark:border-red-400": props.invalid},

                // Transitions
                "transition-all",
                "duration-200",

                // States
                {"hover:border-askr-green": !props.invalid},
                {
                    "outline-none outline-offset-0 ring ring-askr-green-400/50 dark:ring-askr-green-300/50":
                        state.focused,
                },

                // Misc
                "cursor-pointer",
                "select-none",
                {
                    "opacity-60": props.disabled,
                    "pointer-events-none": props.disabled,
                    "cursor-default": props.disabled,
                },
            ],
        };
    },
    label: ({props, parent}) => ({
        class: [
            //Font
            "leading-[normal]",

            // Display
            "block",
            "flex-auto",

            // Color and Background
            "bg-transparent",
            "border-0",
            {
                "text-stone-800 dark:text-white/80": props.modelValue != undefined,
                "text-stone-400 dark:text-stone-500": props.modelValue == undefined,
            },
            "placeholder:text-stone-400 dark:placeholder:text-stone-500",

            // Sizing and Spacing
            "w-[1%]",
            "p-3",
            {"pr-7": props.showClear},

            //Shape
            "rounded-none",

            // Transitions
            "transition",
            "duration-200",

            // States
            "focus:outline-none focus:shadow-none",

            // Filled State *for FloatLabel
            {
                filled: parent.instance?.$name == "FloatLabel" && props.modelValue !== null,
            },

            // Misc
            "relative",
            "cursor-pointer",
            "overflow-hidden overflow-ellipsis",
            "whitespace-nowrap",
            "appearance-none",
        ],
    }),
    dropdown: {
        class: [
            // Flexbox
            "flex items-center justify-center",
            "shrink-0",

            // Color and Background
            "bg-transparent",
            "text-stone-500",

            // Size
            "w-12",

            // Shape
            "rounded-tr-md",
            "rounded-br-md",
        ],
    },
    overlay: ({instance}) => {
        return {
            class: [
                // Position
                "absolute top-0 left-0 !mt-0 w-full md:w-auto h-screen md:h-auto flex flex-col md:-block justify-center items-center py-3 md:py-0 overflow-hidden overscroll-none",

                // Shape
                "border-0 dark:border",
                "md:rounded-md",
                "shadow-xl shadow-stone-700 dark:shadow-black",

                // Color
                "bg-stone-900/50 md:bg-white dark:bg-stone-950/80",
                "text-stone-800 dark:text-white/80",
                "dark:border-stone-700",
            ],
        };
    },
    listContainer: {
        style: {maxHeight: "calc(100vh - 2rem)"},
        class: [
            "bg-white dark:bg-stone-800 rounded-md shadow-xl shadow-stone-700 dark:shadow-black w-full md:w--auto mx-3 md:mx-0 grow w-full",
            // Sizing
            "max-h--full md:max-h-[60rem]",

            // Misc
            "overflow-auto overscroll-none",
        ],
    },
    list: {
        class: "py--3 list-none m-0 divide-y dark:divide-stone-700",
    },
    option: ({context}) => ({
        class: [
            // Font
            "font-normal",
            "leading-none",

            // Position
            "relative",
            "flex items-center",

            // Shape
            "border-0",
            "rounded-none",

            // Spacing
            "m-0",
            "py-5 px-5",

            // Colors
            {
                "text-stone-700 dark:text-white/80": !context.focused && !context.selected,
                "bg-stone-200 dark:bg-stone-600/60": context.focused && !context.selected,
                // 'text-stone-700 dark:text-white/80': context.focused && !context.selected,
                "bg-askr-green-50/10": context.selected,
            },

            //States
            {
                "hover:bg-stone-100 dark:hover:bg-stone-600/80": !context.focused && !context.selected,
            },
            {"hover:bg-stone-50 dark:hover:bg-stone-600/80": context.selected},
            "focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset focus-visible:ring-askr-green-400/50 dark:focus-visible:ring-askr-green-300/50",

            // Transitions
            "transition-shadow",
            "duration-200",

            // Misc
            {"pointer-events-none cursor-default": context.disabled},
            {"cursor-pointer": !context.disabled},
            "overflow-hidden",
            "whitespace-nowrap",
        ],
    }),
    optionGroup: {
        class: [
            //Font
            "font-bold",

            // Spacing
            "m-0",
            "py-3 px-5",

            // Color
            "text-stone-800 dark:text-white/80",
            "bg-stone-50 dark:bg-stone-600/80",

            // Misc
            "cursor-auto",
        ],
    },
    optionCheckIcon: "relative -ms-1.5 me-1.5 text-stone-700 dark:text-white/80 w-4 h-4",
    optionBlankIcon: "w-4 h-4",
    emptyMessage: {
        class: [
            // Font
            "leading-none",

            // Spacing
            "py-3 px-5",

            // Color
            "text-stone-800 dark:text-white/80",
            "bg-transparent",
        ],
    },
    header: {
        class: [
            // Spacing
            "py-3 px-5 w-full",
            "m-0",

            //Shape
            "border-b",
            "rounded-tl-md",
            "rounded-tr-md",

            // Color
            "text-stone-700 dark:text-white/80",
            "bg-stone-100 dark:bg-stone-800",
            "border-stone-300 dark:border-stone-700",
        ],
    },
    clearIcon: {
        class: [
            // Color
            "text-stone-500",

            // Position
            "absolute",
            "top-1/2",
            "right-12",

            // Spacing
            "-mt-2",
        ],
    },
    loadingIcon: {
        class: "text-stone-400 dark:text-stone-500 animate-spin",
    },
    transition: {
        enterFromClass: "opacity-0 md:scale-y-[0.8]",
        enterActiveClass: "transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]",
        leaveActiveClass: "transition-opacity duration-100 ease-linear",
        leaveToClass: "opacity-0",
    },
};
